import React, { useContext } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Form, Field, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import * as qs from 'query-string';
import { notificationMessages } from '../../../i18n/common';
import { TextAreaWithValidation } from '../../../components/prime-formik';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { DECLINE_INVITATION } from '../services/account-invitation-decline.service';
import { buildAccountInvitationDeclineFormInitialValues, buildAccountInvitationDeclineFormValidationSchema } from '../helpers/account-invitation-decline.helper';

const messages = defineMessages({
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const AccountInvitationDecline = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const location = useLocation();

  const growl = useContext(NotificationContext);

  const { token } = qs.parse(location.search);

  const [declineClientInvitationMutation] = useMutation(DECLINE_INVITATION);

  const handleSubmit = async (values) => {
    const { message } = values;

    try {
      await declineClientInvitationMutation({
        variables: {
          input: {
            token,
            message,
          },
        },
      });
      growl.show({ severity: 'info', detail: formatMessage(notificationMessages.success) });
      history.push('/');
    } catch (error) {
      growl.show({ severity: 'error', detail: error.message, sticky: true });
    }
  };

  const initialValues = buildAccountInvitationDeclineFormInitialValues();
  const validationSchema = buildAccountInvitationDeclineFormValidationSchema();

  return (
    <div className="p-grid p-justify-center">
      <div className="p-sm-12 p-md-10 p-lg-8">
        <Panel>
          <FormattedMessage
            id="decline-account-invitation.form.body-text"
            // eslint-disable-next-line max-len
            defaultMessage="Please give us a reason why you do not want to go through with this invitation. Your feedback is much appreciated."
            tagName="h3"
          />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            <Form>
              <div className="p-grid">
                <div className="p-grid p-col-6">
                  <div className="p-col-12">
                    <Field id="message" name="message" labelText="Message" component={TextAreaWithValidation} />
                    <Button type="button" label={formatMessage(messages.cancel)} onClick={() => history.goBack()} />
                    <Button type="submit" label={formatMessage(messages.submit)} />
                  </div>
                </div>
              </div>
            </Form>
          </Formik>
        </Panel>
      </div>
    </div>
  );
};

export default AccountInvitationDecline;
